import * as React from 'react';
import { SVGProps } from 'react';

const IconChatFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.5 25C20.851 25 26 19.851 26 13.5S20.851 2 14.5 2 3 7.149 3 13.5c0 1.663.353 3.243.988 4.67l-1.949 6.625a.94.94 0 0 0 1.166 1.166l6.625-1.949A11.46 11.46 0 0 0 14.5 25Z" />
  </svg>
);
export default IconChatFilledSizeL;
